import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allMachines } from 'app/mocks/data/machines/all'

import { api } from 'app/utils/constants'

export const updateMachine = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.ALL}:id/`,
    async ({ request, params }) => {
        const data = await request.json()
        const { id } = params

        const machineFound = allMachines.find(
            (machine) => machine.id.toString() === id,
        )

        // Wrong data
        if (!data) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        // Not found
        if (!machineFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        const machineToReturn = {
            ...machineFound,
            // @ts-expect-error Wait type
            ...data,
        }

        return HttpResponse.json(machineToReturn)
    },
)
